export const SIGN_BUTTON_ID = '__sizeid-sign-button';
